"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_ERROR_MESSAGES = void 0;
const globalErrorCode_1 = require("../../../global/model/error/globalErrorCode");
const globalErrorMessages_1 = require("../../../global/model/error/globalErrorMessages");
const authErrorCode_1 = require("./authErrorCode");
const AUTH_ERROR_MESSAGES = {};
exports.AUTH_ERROR_MESSAGES = AUTH_ERROR_MESSAGES;
AUTH_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN] =
    globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN];
AUTH_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_ADMIN_TOKEN] =
    globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_ADMIN_TOKEN];
AUTH_ERROR_MESSAGES[authErrorCode_1.AuthErrorCode.INVALID_IDENTIFIER] =
    'The provided value for the email/username property is invalid. It must be a non-empty string';
AUTH_ERROR_MESSAGES[authErrorCode_1.AuthErrorCode.INVALID_EMAIL] =
    'The provided value for the email user property is invalid. It must be a string email address.';
AUTH_ERROR_MESSAGES[authErrorCode_1.AuthErrorCode.INVALID_PASSWORD] =
    'The provided value for the password user property is invalid. It must be a string with at least six characters.';
AUTH_ERROR_MESSAGES[authErrorCode_1.AuthErrorCode.INVALID_USERNAME] =
    'The provided value for the username user property is invalid. It must be a non-empty string';
AUTH_ERROR_MESSAGES[authErrorCode_1.AuthErrorCode.USER_NOT_FOUND] =
    'There is no existing user record corresponding to the provided identifier or the password is invalid for the given email.';
AUTH_ERROR_MESSAGES[authErrorCode_1.AuthErrorCode.INVALID_URL] =
    'The provided value for the url property is invalid. It must be a non-empty string';
AUTH_ERROR_MESSAGES[authErrorCode_1.AuthErrorCode.INVALID_CODE] =
    'The provided value for the code property is invalid. It must be a non-empty string';
AUTH_ERROR_MESSAGES[authErrorCode_1.AuthErrorCode.INVALID_PASSWORD_CONFIRMATION] =
    'The password confirmation should have the same value as password';
AUTH_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE] =
    globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE];
//# sourceMappingURL=authErrorMessages.js.map